import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';

import ShowOffSiteInfo from '../../ShowOffSiteInfo';

const VehicleCardContainer = ({
	children,
	forwardedRef,
	inventoryIndex,
	isFeaturedPromotion,
	isOffsite,
	setShowOffSite,
	uuid
}) => {
	const cardClasses = setClassNames([
		'box',
		'box-border',
		'vehicle-card',
		'vehicle-card-detailed',
		'vehicle-card-horizontal',
		// TODO: confirm these classes don't break anything
		setShowOffSite && 'vehicle-card-fade position-relative',
		isFeaturedPromotion && 'vehicle-card-featured',
		isOffsite && 'vehicle-offsite'
	]);

	return (
		<li
			ref={forwardedRef}
			key={uuid}
			className={cardClasses}
			data-uuid={uuid}
			data-index={inventoryIndex}
			style={{ position: 'relative' }} // I think we can always have position relative set here?
		>
			{setShowOffSite && (
				<ShowOffSiteInfo handleClick={() => setShowOffSite(true)} />
			)}
			{children}
		</li>
	);
};

VehicleCardContainer.propTypes = {
	children: PropTypes.node.isRequired,
	inventoryIndex: PropTypes.number.isRequired,
	setShowOffSite: PropTypes.func,
	isFeaturedPromotion: PropTypes.bool,
	isOffsite: PropTypes.bool,
	forwardedRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	uuid: PropTypes.string.isRequired
};

export default VehicleCardContainer;
